/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {
    @Input() percent = 0;
    @Input() radius = 8;

    get strockDashOffset(): number {
        const c = Math.PI * 80 * 2;
        return ((100 - this.percent) / 100) * c;
    }

    ngOnInit(): void {
    }
}
